export default {
  SHOW_MESSAGE(state, settings) {
    state.color = settings.color;
    state.icon = settings.icon;
    state.text = settings.text;
  }
};
